import { render, staticRenderFns } from "./NewDownline.vue?vue&type=template&id=f8507454&scoped=true&"
import script from "./NewDownline.vue?vue&type=script&lang=ts&"
export * from "./NewDownline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8507454",
  null
  
)

export default component.exports